import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { path: '/gastgeber',
    name: 'Gastgeber',
    component: () => import(/* webpackChunkName: "Gastgeber" */ '../views/Gastgeber.vue'),
    meta: {
      title: 'Gastgeber'
    }
  },
  { path: '/zimmer',
    name: 'Zimmer',
    component: () => import(/* webpackChunkName: "Zimmer" */ '../views/Zimmer.vue'),
    meta: {
      title: 'Zimmer'
    }
  },
  { path: '/anfahrt',
    name: 'Anfahrt',
    component: () => import(/* webpackChunkName: "Anfahrt" */ '../views/Anfahrt.vue'),
    meta: {
      title: 'Anfahrt'
    }
  },
  { path: '/preise',
    name: 'Preise',
    component: () => import(/* webpackChunkName: "Preise" */ '../views/Preise.vue'),
    meta: {
      title: 'Preise'
    }
  },
  { path: '/kultur',
    name: 'Kultur',
    component: () => import(/* webpackChunkName: "Kultur" */ '../views/Kultur.vue'),
    meta: {
      title: 'Kultur'
    }
  },
  { path: '/kontakt',
    name: 'Kontakt',
    component: () => import(/* webpackChunkName: "Kontakt" */ '../views/SimpleKontakt.vue'),
    meta: {
      title: 'Kontakt'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active-view',
  routes
})

export default router
